
import React from 'react';
import { Check, RefreshCw, AlertCircle } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface NotificationHeaderProps {
  realtimeStatus: 'connected' | 'disconnected' | 'error';
  unreadCount: number;
  handleMarkAllAsRead: () => void;
  reconnect: () => void;
  toast: any;
  filter: 'all' | 'unread';
  onFilterChange: (filter: 'all' | 'unread') => void;
}

export const NotificationHeader: React.FC<NotificationHeaderProps> = ({
  realtimeStatus,
  unreadCount,
  handleMarkAllAsRead,
  reconnect,
  toast,
  filter,
  onFilterChange,
}) => {
  return (
    <div className="px-4 pt-4 pb-2">
      <div className="flex items-center justify-between mb-3">
        <div className="font-semibold text-base flex items-center gap-2">
          Notifications
          {realtimeStatus === 'error' && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <AlertCircle className="h-4 w-4 text-destructive" />
                </TooltipTrigger>
                <TooltipContent>
                  <p>Connection error</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </div>
        <div className="flex items-center gap-1">
          {realtimeStatus === 'error' && (
            <Button variant="ghost" size="sm" className="h-7 text-xs" onClick={() => {
              reconnect();
              toast({ title: "Reconnecting", description: "Attempting to reconnect to notification service" });
            }}>
              <RefreshCw className="h-3.5 w-3.5 mr-1" />
              Retry
            </Button>
          )}
          {unreadCount > 0 && (
            <Button variant="ghost" size="sm" className="h-7 text-xs text-muted-foreground hover:text-foreground" onClick={handleMarkAllAsRead}>
              <Check className="h-3.5 w-3.5 mr-1" />
              Mark all read
            </Button>
          )}
        </div>
      </div>
      
      {/* Tab filters */}
      <div className="flex gap-1">
        <button
          onClick={() => onFilterChange('all')}
          className={`px-3 py-1 text-xs font-medium rounded-full transition-colors ${
            filter === 'all'
              ? 'bg-primary text-primary-foreground'
              : 'text-muted-foreground hover:text-foreground hover:bg-accent'
          }`}
        >
          All
        </button>
        <button
          onClick={() => onFilterChange('unread')}
          className={`px-3 py-1 text-xs font-medium rounded-full transition-colors ${
            filter === 'unread'
              ? 'bg-primary text-primary-foreground'
              : 'text-muted-foreground hover:text-foreground hover:bg-accent'
          }`}
        >
          Unread{unreadCount > 0 ? ` (${unreadCount})` : ''}
        </button>
      </div>
    </div>
  );
};
